// extracted by mini-css-extract-plugin
module.exports =  {"default":"_32bbee5fda--default--npsf1","light":"_32bbee5fda--light--F6CVM","outline":"_32bbee5fda--outline--MW3WN"};